import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/supporter/$supporterId/settings/countries")({
  component: lazyRouteComponent(() => import("./+Countries")),
  head: () => ({ meta: seo({ title: "International Settings" }) }),
});
